import React, { useState } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'

// Fasst gleichartige, nicht dringende Aufforderungen ab 2 Stück zu einer Sammelzeile zusammen
// ("3 Flüge ohne Pilot – anzeigen"), aufklappbar zu den Einzelzeilen. Klappzustand je Art in localStorage.

const KEY = 'pilot-hub-aufforderungen-offen'

function lesen(): string[] {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]') } catch { return [] }
}
function schreiben(liste: string[]) {
  try { localStorage.setItem(KEY, JSON.stringify(liste)) } catch { /* egal */ }
}

export function AufforderungsGruppe({ id, anzahl, titel, icon, farbe, testid, children }: {
  id: string
  anzahl: number
  /** Text der Sammelzeile ohne "anzeigen", z. B. "3 Flüge ohne Pilot" */
  titel: string
  icon?: React.ReactNode
  /** Tailwind-Klassen für Rahmen/Hintergrund/Text */
  farbe: string
  testid?: string
  children: React.ReactNode
}) {
  const [offen, setOffen] = useState(() => lesen().includes(id))
  if (anzahl < 2) return <>{children}</>
  const umschalten = () => {
    const neu = !offen
    setOffen(neu)
    schreiben(neu ? [...lesen().filter(x => x !== id), id] : lesen().filter(x => x !== id))
  }
  return (
    <div className="space-y-2" data-testid={testid}>
      <button type="button" onClick={umschalten} aria-expanded={offen}
        className={`flex min-h-[48px] w-full items-center gap-2 rounded-xl border px-3 py-2 text-left text-sm font-semibold ${farbe}`}>
        {icon}
        <span className="min-w-0 flex-1 truncate">{titel} – {offen ? 'ausblenden' : 'anzeigen'}</span>
        {offen ? <ChevronUp className="h-5 w-5 shrink-0" /> : <ChevronDown className="h-5 w-5 shrink-0" />}
      </button>
      {offen && children}
    </div>
  )
}
